import { BaseEvents } from '@/shared/utils';
import { PaginationQueryParams } from './types/pagination';

export const DashboardEventKeys = {
  contentsInProgress: {
    view: 'dashboard/contents-in-progress/view',
  },
  customer: {
    view: 'dashboard/customer/view',
  },
  favouriteLearningPath: {
    view: 'dashboard/favourite-learning-path/view',
  },
  favouriteLessons: {
    view: 'dashboard/favourite-lessons/view',
  },
  seentContents: {
    view: 'dashboard/seen-contents/view',
  },
  trendingSeries: {
    view: 'dashboard/trending-series/view',
  },
  upComingLives: {
    view: 'dashboard/upcoming-lives/view',
  },
  favourites: {
    create: 'favourites/create',
    delete: 'favourites/delete',
  },
  redirects: {
    to: 'redirects/to',
  },
} as const;

export interface DashboardEvents extends BaseEvents {
  'dashboard/contents-in-progress/view': PaginationQueryParams;
  'dashboard/customer/view': { email: string };
  'dashboard/favourite-learning-path/view': PaginationQueryParams;
  'dashboard/favourite-lessons/view': PaginationQueryParams;
  'dashboard/seen-contents/view': PaginationQueryParams;
  'dashboard/trending-series/view': PaginationQueryParams;
  'dashboard/upcoming-lives/view': PaginationQueryParams;
  'favourites/create': { documentId: string };
  'favourites/delete': { documentId: string };
  'redirects/to': { url: string; isExternalPage: boolean };
}
